import { render, staticRenderFns } from "./lx.vue?vue&type=template&id=3dcb17f4&scoped=true"
import script from "./lx.vue?vue&type=script&lang=js"
export * from "./lx.vue?vue&type=script&lang=js"
import style0 from "./lx.vue?vue&type=style&index=0&id=3dcb17f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcb17f4",
  null
  
)

export default component.exports